import { LinkedFieldWithLayoutSettings } from '@Components/LinkedFieldWithLayoutSettings';
import { serviceColumns } from '@Constants/TableColumns';
import { buildPositionElementId } from '@Hooks/Navigation';
import { EnumFrontendLayoutSetting, type ApiRequisitionPosition, type ApiService } from '@Model';
import { FrameEditService } from '@Modules/Stammdaten';
import {
    DivWithSpacing,
    getSpacings,
    Grid,
    GridColumns,
    NumberInput,
    useGuiBinder,
    useLinkedFieldInFrame,
    useTranslate,
    type ISubFrameBodyProps,
} from '@synqo/frontend-component-library';
import { forwardRef } from 'react';

export const RequisitionPosition = forwardRef<HTMLDivElement, ISubFrameBodyProps<ApiRequisitionPosition>>(
    function RequisitionPosition(props, ref) {
        const i18n = useTranslate('');

        const binder = useGuiBinder<ApiRequisitionPosition>(props);
        const linkService = useLinkedFieldInFrame(props, 'service', FrameEditService);

        return (
            <DivWithSpacing
                ref={ref}
                id={buildPositionElementId(props.data.id)}
                padding={getSpacings('sm')}
                className="w-4/5"
                name="Position"
            >
                <Grid columns={12}>
                    <GridColumns spans={[9, 3]}>
                        <LinkedFieldWithLayoutSettings<ApiService>
                            layoutSettingsContext={EnumFrontendLayoutSetting.ServicesTableLayout}
                            {...binder.bindToLinkProperty(linkService.linkApi)}
                            {...linkService.events}
                            columns={serviceColumns}
                            label={i18n('Leistung')}
                        />
                        <NumberInput {...binder.bindToProp<number>('quantity')} label={i18n('Menge')} />
                    </GridColumns>
                </Grid>
            </DivWithSpacing>
        );
    },
);
